import { Route, Routes } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/free-mode";
import 'swiper/css/autoplay';
import "./traduction/i18n"
import Aos from 'aos'
import 'aos/dist/aos.css'
import "react-quill-new/dist/quill.snow.css";
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import './App.css';
// import { Loader } from './pages/Layouts';
import 'jquery/dist/jquery.min.js';
import moment from 'moment';
import { useEffect } from 'react';
import { Toaster } from './components/ui/Toaster';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from './context/authContext.js'
import BusinessConnect from './pages/Evenements/BusinessConnect';
import Layouts from './pages/Layouts';
const Events = lazy(() => import('./pages/Admin/Events'));
const MembreDetail = lazy(() => import('./pages/Admin/MembreDetail'));
const Membres = lazy(() => import('./pages/Admin/Membres'));

const Layout = lazy(() => import('./components/Layouts/Layout'));
const NotFoun = lazy(() => import('./pages/Error/NotFoun'));
const Zone = lazy(() => import('./pages/Bureau-Afrique/Zone'));
const ListActivite = lazy(() => import('./pages/Activites/ListActivite'));
const DetailEvenements = lazy(() => import('./pages/Evenements/DetailEvenements'));
const ActualiteDetail = lazy(() => import('./pages/Actualites/ActualiteDetail'));
const CccaRevue = lazy(() => import('./pages/CccaRevue'));
const RevueDetail = lazy(() => import('./pages/CccaRevue/RevueDetail'));
const BureauAfrique = lazy(() => import('./pages/Apropos/BureauAfrique'));
const BureauExpertise = lazy(() => import('./pages/Apropos/BureauExpertise'));
const LayoutsProgrammes = lazy(() => import('./pages/Programmes/LayoutsProgrammes'));
const ProgrammesDetail = lazy(() => import('./pages/Programmes/ProgrammesDetail'));
const NotFound = lazy(() => import('./pages/Error/NotFound'));
const LayoutsExpert = lazy(() => import('./pages/NosExperts/LayoutExpert'));
const NosExpert = lazy(() => import('./pages/NosExperts'));

const Missions = lazy(() => import('./pages/Missions'));
const Services = lazy(() => import('./pages/Services'));
const login = lazy(() => import('./pages/Login/Login'));
const inscription = lazy(() => import('./pages/Login/Inscription'));
const BureauxAfrique = lazy(() => import('./pages/Bureau-Afrique/BureauxAfrique'));
const AfriqueLayouts = lazy(() => import('./pages/Bureau-Afrique/AfriqueLayouts'));
const indexes = lazy(() => import('./pages/Bureau-Afrique/indexes'));
const Pays = lazy(() => import('./pages/Bureau-Afrique/Pays'));

const DevenirMembre = lazy(() => import('./pages/DevenirMembre'));
const LayoutsDetail = lazy(() => import('./pages/Services/LayoutsDetail'));
const ServiceDetails = lazy(() => import('./pages/Services/ServiceDetails'));
const Actualites = lazy(() => import('./pages/Actualites'));
const AdminActualiteDetail = lazy(() => import('./pages/Admin/ActualiteDetail'));
const Activites = lazy(() => import('./pages/Activites'));
const LayoutsActivite = lazy(() => import('./pages/Activites/LayoutsActivite'));
const ActiviteDetail = lazy(() => import('./pages/Activites/ActiviteDetail'));

const Formation = lazy(() => import('./pages/Formatione copy'));
const Incubations = lazy(() => import('./pages/Incubations'));
const Contacts = lazy(() => import('./pages/Contact'));
const Evenements = lazy(() => import('./pages/Evenements'));
const Contact = lazy(() => import('./pages/Apropos/Contact'));
const Membre = lazy(() => import('./pages/Apropos/Membre'))
const Presentations = lazy(() => import('./pages/Apropos/Presentations'));
const ConseilAdministration = lazy(() => import('./pages/Apropos/ConseilAdministration'));
const DirectionGenerale = lazy(() => import('./pages/Apropos/DirectionGenerale'));
const Gallerie = lazy(() => import('./pages/Apropos/Gallerie'));
const LayoutsApropos = lazy(() => import('./pages/Apropos/LayoutsApropos'));
const Home = lazy(() => import('./pages/Home'));
// const Layouts = lazy(() => import('./pages/Layouts'));

const Acceuil = lazy(() => import('./pages/Acceuil'));
const Dashboard = lazy(() => import('./pages/Admin/Dashboard'));
// const Activities = lazy(() => import('./pages/Admin/Other/Activities'));
const News = lazy(() => import('./pages/Admin/Actualite'));
const EventDetail = lazy(() => import('./pages/Admin/EventDetail'));
const AdminUsers = lazy(() => import('./pages/Admin/Users'));
const AdminGalerie = lazy(() => import('./pages/Admin/Galerie'));
const AdminCaroussel = lazy(() => import('./pages/Admin/Caroussel'));

function App() {
  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: "ease-in-out",
      once: true,
    });
  }, []);
  const { userConnected } = useAuth()
  const { i18n } = useTranslation()
  moment.locale(i18n.language);

  return (
    <>
      <Toaster />
        <Routes>
          <Route path="/">
            {/* <Route index Component={Acceuil} /> */}
            {!userConnected && <Route path="/login" Component={login} />}
            <Route path="/inscription" Component={inscription} />
          </Route>
          <Route path="/" element={<Layouts />}>
            <Route index Component={Home} />
            <Route path="Formations" Component={Formation} />
            <Route path="Mission" Component={Missions} />
            <Route path="business-connect" Component={BusinessConnect} />
            <Route path="Activites/">
              <Route index Component={Activites} />
              <Route path="List" Component={ListActivite} />
              <Route path=":nameactivite" Component={LayoutsActivite}>
                <Route index Component={ActiviteDetail} />
              </Route>
            </Route>

            <Route path="nos-programmes-pygmalion/">
              <Route path=":nameprog" Component={LayoutsProgrammes}>
                <Route index Component={ProgrammesDetail} />
              </Route>
            </Route>
            <Route path="Services/">
              <Route index Component={Services} />
              <Route path=":nameservice" Component={LayoutsDetail}>
                <Route index Component={ServiceDetails} />
              </Route>
            </Route>
            <Route path="Apropos-de-nous/" Component={LayoutsApropos}>
              <Route path="Présentation" Component={Presentations} />
              <Route path="Conseil d'administration">
                <Route index Component={ConseilAdministration} />
              </Route>
              <Route path="Direction Exécutive" Component={DirectionGenerale} />
              <Route path="Galérie" Component={Gallerie} />
              <Route path="Bureau Afrique" Component={BureauAfrique} />
              <Route path="Bureau d'Expertise" Component={BureauExpertise} />
              <Route path="Contacts" Component={Contact} />
              <Route path="Membres" Component={Membre} />
            </Route>
            <Route path="nos-experts/" Component={LayoutsExpert}>
              <Route path=':id' Component={NosExpert} />
            </Route>
            <Route path="Incubation" Component={Incubations} />
            <Route path="Evenements/">
              <Route index Component={Evenements} />
              <Route path=":id" Component={DetailEvenements} />
            </Route>
            <Route path="Actualites/">
              <Route index Component={Actualites} />
              <Route path=":id" Component={ActualiteDetail} />
            </Route>
            <Route path="CCCA REVUE/">
              <Route index Component={CccaRevue} />
              <Route path=":id" Component={RevueDetail} />
            </Route>
            <Route path="Devenir-membre" Component={DevenirMembre} />
            <Route path="Contacts" Component={Contacts} />
            <Route path="Bureau/">
              <Route index Component={indexes} />
              <Route path=":nation/">
                <Route index Component={Pays} />
                <Route path=":zone/">
                  <Route index Component={Zone} />
                  <Route path=":region" Component={AfriqueLayouts}>
                    <Route index Component={BureauxAfrique} />
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>
          {/* <Route path="/a/Devenir-membre" Component={Layouts}>
            <Route index Component={DevenirMembre} />
          </Route> */}

          <Route path="*" Component={NotFound} />
          {/* <Route path="*" Component={ConstructPage} /> */}
          {userConnected &&
            <Route path="/admin" element={<Layout />}>
              <Route path='dashboard' element={<Dashboard />} />
              <Route path="news" element={<News />} />
              <Route path="news/:id" element={<AdminActualiteDetail />} />
              <Route path="events" element={<Events />} />
              <Route path="events/:id" element={<EventDetail />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="galeries" element={<AdminGalerie />} />
              <Route path="baniere" element={<AdminCaroussel />} />
              <Route path="*" Component={NotFoun} />
              <Route path="membres" element={<Membres />} />
              <Route path="membres/:id" element={<MembreDetail />} />
            </Route>
          }
        </Routes>
      {/* </Suspense> */}
    </>
  );
}

export default App;
